import Cookie from "js-cookie";

// Reads the logged-in user's account type from the same "data" cookie
// already used elsewhere (e.g. NavamChartLayout.js, chartLayout.js).
export function getAccountType() {
    const cookieUserData = Cookie.get("data");
    if (!cookieUserData) return null;
    try {
        return JSON.parse(cookieUserData).account_type || null;
    } catch (err) {
        return null;
    }
}

// Live vitals over WebSocket are only available for Basic-tier accounts on
// the new Android app right now. Every other tier stays on the existing
// 10-second REST refresh, unconditionally.
export function isBasicAccount() {
    return getAccountType() === "Basic";
}
